<template>
  <v-container fluid class="bg-image" ref="container">
    <v-row>
      <v-btn @click="$emit('close')" color="primary" class="text-capitalize" text>
        <v-icon>mdi-chevron-left</v-icon>
        {{$t('go_back')}}
      </v-btn>
    </v-row>
    <v-row justify="center">
      <v-img :src="imageLogoUrlBlue" max-height="150px" contain aspect-ratio="1.7"></v-img>
    </v-row>
    <v-row justify="center" ref="row">
      <v-col cols="12" md="8" ref="column">
        <v-card class="transparent-card" flat>
          <v-card-title primary-title class="py-0 py-7">
            <v-row justify="center">
              <span class="text-h5 font-weight-light primary--text">TERMS & CONDITIONS</span>
            </v-row>
          </v-card-title>
          <v-card-subtitle class="font-weight-regular">
            <v-row justify="center">
              <span
                class="font-weight-medium subtitle-1 primary--text"
              >You must read and agree to the terms and conditions before registering</span>
            </v-row>
          </v-card-subtitle>
          <v-card-text @scroll="watchScroll" class="terms-conditions-text" ref="terms-conditions">
            <v-row>
              <v-col cols="12">
                <terms-and-conditions-text />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pt-3">
            <v-row justify="center">
              <v-col cols="12" class="ma-0 pa-0 text-center">
                <v-btn
                  @click="$emit('accepted')"
                  :disabled="disableButton"
                  class="py-6 px-11"
                  large
                  color="primary"
                >Accept</v-btn>
              </v-col>
              <v-col cols="12" class="ma-0 pa-0 text-center">
                <v-btn
                  @click="$emit('close')"
                  large
                  text
                  color="primary"
                  class="mt-1"
                  ref="acceptButton"
                >Cancel</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  components: {
    TermsAndConditionsText: () => import('@/components/TermsAndConditionsText')
  },
  data () {
    return {
      disableButton: true
    }
  },
  mounted () {

  },
  methods: {
    watchScroll (event) {
      var agreementTextElement = event.srcElement
      if ((agreementTextElement.scrollTop + agreementTextElement.offsetHeight) >= agreementTextElement.scrollHeight) {
        this.disableButton = false
        const el = this.$refs.acceptButton.$el
        el.scrollIntoView(true)
      }
    }
  },
  beforeDestroy () {
    this.disableButton = true
  }

}
</script>

<style lang="scss" scoped>
.bg-image {
  background: rgba($color: #f0f0f0, $alpha: 1);
}
.transparent-card {
  background: rgba(255, 255, 255, 0);
}
.terms-conditions-text {
  max-height: 55vh;
  overflow-x: scroll;
  overflow-y: scroll;
}
a {
  text-decoration: underline;
}
</style>
